<template>
	<div class="pageContainer targetPage flexCloumn">
		<el-row class="searchBar flexBetween" style="flex-wrap: wrap;width:100%">
			<div class="flexStart flex_1" style="flex-wrap:wrap;">
				<span>搜索关键字：</span>
				<el-input v-model="searchForm.keyword" size="small" placeholder="请输入" clearable style="max-width: 200px;" />
        <el-select v-model="searchForm.project_id" size="small" placeholder="选择体育项目" clearable style="margin-left: 10px;">
          <el-option v-for="(item,index) in sportProjects"
                     :label="item.project_name"
                     :value="item.id" :key="index"></el-option>
        </el-select>
				<el-button size="small" icon="el-icon-search" type="primary" style="margin-left: 10px;" @click="getList">查询</el-button>

				<div style="float:right">
					<el-button size="small" icon="el-icon-plus" type="primary" plain
                     style="margin-left: 10px;" @click="handleAdd">新增
					</el-button>
				</div>
			</div>
		</el-row>
		<div class="dividerBar"></div>
    <el-table v-tableFit :data="tableData" height="100%" size="small" stripe border style="width:fit-content;width:100%;">
      <el-table-column type="selection" width="55"></el-table-column>
      <el-table-column prop="lesson_name" label="课程名称"  align="center"></el-table-column>
      <el-table-column prop="lesson_code" label="课程编号"  align="center"></el-table-column>
      <el-table-column prop="lesson_desc" label="课程描述"  align="center"></el-table-column>
      <el-table-column prop="teacher_name" label="授课教师"  align="center"></el-table-column>
      <el-table-column prop="project_name" label="体育项目"  align="center"></el-table-column>
      <el-table-column prop="sort" label="排序" width="80" align="center">
        <template slot-scope="scope">
          <div>{{ scope.row.sort }}</div>
        </template>
      </el-table-column>

      <el-table-column fixed="right" label="操作" width="250" align="center">
        <template slot-scope="scope">
          <el-popconfirm width="250" confirmButtonText='确定' cancelButtonText='取消' icon="el-icon-info"
                         iconColor="red" @confirm="handleDel(scope.row)" placement="left" title="是否确定删除？">
            <el-tag class="pointer" slot="reference" type="danger" size="mini"
                    style="margin-right: 10px;">删除</el-tag>
          </el-popconfirm>
          <el-tag class="pointer" @click="handleModify(scope.row)" type="primary" size="mini">修改</el-tag>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination @current-change="handlePageChange" @size-change="handleSizeChange" :current-page="page.current_page"
                   :page-size="page.per_page" :page-sizes="[10, 20, 50, 100, 200, 500, 1000]"
                   layout="total, prev, pager, next,sizes, jumper" :total="page.count">
    </el-pagination>

		<el-dialog title="添加/修改" :visible.sync="isShowModal" :close-on-click-modal="false" :destroy-on-close="true"
			custom-class="cus_dialog">
			<el-form :model="formData" ref="ruleform" label-width="120px"
				style="max-height: 500px;overflow-y: auto;min-height: 300px;">
				<el-form-item label="课程名称" prop="lesson_name" :rules="[{required:true,message:'请输入课程名称',trigger:'blur'}]">
					<el-input v-model.trim="formData.lesson_name" style="width: 50%" />
				</el-form-item>
				<el-form-item label="课程代码">
					<el-input v-model.trim="formData.lesson_code" style="width: 50%" />
				</el-form-item>
        <el-form-item label="课程描述">
          <el-input type="textarea" :autosize="{minRows:3}" maxlength="500" show-word-limit v-model.trim="formData.lesson_desc" style="width: 50%" />
        </el-form-item>
        <el-form-item label="授课教师" prop="teacher_id" :rules="[{required:true,message:'请选择授课教师',trigger:'change'}]">
          <el-select v-model="formData.teacher_id" placeholder="请选择授课教师" style="width:50%">
            <el-option v-for="(item,index) in teachers" :label="item.username" :value="item.id" :key="index"></el-option>
          </el-select>
        </el-form-item>
				<el-form-item label="体育项目" prop="project_id" :rules="[{required:true,message:'请选择体育项目',trigger:'change'}]">
					<el-select v-model="formData.project_id" placeholder="请选择体育项目" style="width:50%">
						<el-option v-for="(item,index) in sportProjects" :label="item.project_name" :value="item.id" :key="index"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="排序号" prop="sort">
					<el-input-number :min="0" v-model.trim="formData.sort" placeholder="请输入排序号(数字)"
						controls-position="right" />
				</el-form-item>
			</el-form>
			<template slot="footer">
        <el-button size="small" type="default" @click="isShowModal = false">取消</el-button>
        <el-button size="small" type="primary" @click="submitForm">保存</el-button>
      </template>
		</el-dialog>
	</div>
</template>
<script>
import tchtree from '../com/tchTree.vue'
import moment from "moment";
export default {
	name: 'dept',
	components: {tchtree},
	data() {
		return {
			visible: false,
			isShowModal: false,
			isShowModalAuth: false,
			importTeacherShow: false,
			modalTitle: '添加',
			DeptUserDialog: false,
			showDeptroleManage: false,
			activeRoleID: "",
			formData: {},
			fgxz: [],
			activeName: 'CN',
			tableData: [],

			teacherList: [],
			editUser: {},
			deptId: null,
			editDeptRole: {},
			deptRoleList: [],
			isShowDeptRole: false,
			biye: 0,

			page: {
				count: 0,
				current_page: 1,
				per_page: 50,
				total_page: 0
			},
			searchForm: {

				ktype: "username",
				keyword: "",
				school_year: ""
			},
			multipleSelection: [],
			treeData: [],
			ckdTreeData: [],
			firstCascaderProps: {
				label: "name",
				children: "children",
			},
			defaultProps: {
				label: 'name',
				value: 'id',
				children: 'children',
				emitPath: false,
				checkStrictly: true
			},
			DataAuth: [],
			showTeacherInfo: false,
			teacher_id: 0,
			schoolYears: [],
      failedImportData: [],
      sportProjects: [],
      teachers: [],
		}
	},

	mounted() {
    this.getSportsProject()
    this.getTeachers()
    this.getList()
	},
	methods: {
    getTeachers() {
      this.$http.post('/api/t_sch_teachers_list',{page:1,pagesize:1000}).then(res => {
        this.teachers = res.data.data
      })
    },
    getSportsProject() {
      this.$http.post('/api/sport_project_list',{page:1,pagesize:100}).then(res => {
        this.sportProjects = res.data.data
      })
    },
    getList() {
      this.$http.post('/api/lesson_list',{
        page: this.page.current_page,
        pagesize: this.page.per_page ? this.page.per_page : 20,
        keyword: this.searchForm.keyword,
        project_id: this.searchForm.project_id,
        lesson_type: 1,
      }).then(res => {
        this.tableData = res.data.data
        this.page = res.data.page
      })
    },
    handleAdd() {
      this.isShowModal = true;
      this.formData = {}
      this.$nextTick(() => {
        this.$refs.ruleform.clearValidate()
      })
    },
		handleModify(row) {
			this.isShowModal = true;
			let formData = JSON.parse(JSON.stringify(row))
			if (formData.roles && formData.roles.length > 0) {
				formData.roles = formData.roles.map(e => { return e.role_id })
				let DataAuth = JSON.parse(JSON.stringify(row.roles))
				for (let item of DataAuth) {
					if (item.dept_data) {
						item.dept_data = item.dept_data.split(",")
					} else {
						item.dept_data = []
					}

				}
				if (DataAuth.length > 0) {
					this.activeRoleID = DataAuth[0].role_id + ""
				}
				this.DataAuth = DataAuth
			} else {
				this.DataAuth = []
			}

			this.formData = formData

			//this.getTechByIds(row.fgxz)
		},
		handleDel(row) {
			this.$http.post("/api/lesson_delete", {
				id: String(row.id)
			}).then(res => {
				this.$message.success('删除成功')
				this.getList();
			})
		},

		submitForm() {
			let params = {
				...this.formData
			}
			this.$refs.ruleform.validate(valid => {
        if (valid) {
          this.$http.post("/api/lesson_edit", params).then(res => {
            this.$message.success('保存成功')
            this.getList()
            this.isShowModal = false;
          })
        }
      });
		},
    handlePageChange(e) {
      this.page.current_page = e
      this.getList()
    },
    handleSizeChange(e) {
      this.page.per_page = e
      this.getList()
    },
	}
}
</script>
<style scoped lang="less" type="text/less">
.app-container {

	.treeContainer {
		height: 100%;
		background-color: #fff;
		box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.12), 0 0 6px 0 rgba(0, 0, 0, 0.04);
		border: 1px solid rgba(220, 223, 230, 0.6);
		margin-right: 20px;
		padding-right: 10px;

		.treeTitle {
			height: 40px;
			display: flex;
			justify-content: flex-start;
			align-items: center;
			color: #409eff;
			padding-left: 6px;
		}
	}
}

.nodetag {
	display: inline-block;
	padding: 0 5px;
	font-size: 12px;
	transform: scale(0.8, 0.8);
	background-color: #409eff;
	color: #fff;
	border-radius: 4px;
}
</style>
